import { ICommodity } from './commodity.model';
import { ICurrencyIndex } from './currency-index.model';
import { IPartner } from './partner.model';

export interface IBank {
  id?: number;
  name?: string;
  description?: string | null;
  imgURL?: string | null;
  userId?: number | null;
  currencyId?: number | null;
  currencyIndex?: ICurrencyIndex | null;
  partnerId?: number | null;
  partnerIdApi?: number | null;
  localPartnerId?: number | null;
  localPartnerIdApi?: number | null;
  partner?: IPartner | null;
  localPartner?: IPartner | null;
  reportForBankStaff?: boolean;
  reportForBranchManager?: boolean;
  reportForAreaManager?: boolean;
  reportForBankManager?: boolean;
  reportForAuditor?: boolean;
  country?: string;
  otp?: boolean;
  transaction_forms?: boolean;
  displayTransactionFee?: boolean;
  displayFeeInTransactionCurrency?: boolean;
  approvalPeriod?: number;
  transactionAmountLimit?: number;
  countryCode?: string;
  agreementDate?: string;
  commodities?: ICommodity[];
  commission?: boolean;
  commissionAmount?: number;
  commissionForEachAmount?: number;
  createdDate?: Date;
  feeCurrency?: string;
  quotationValidityDays?: number;
  commissionLocal?: boolean;
  commodityType?: string;
  quotationMaxExtensionDays?: number;
  localAgreementDate?: string;
  localTransactionAmountLimit?: number;
  localFeeCurrency?: string;
  quotationEnabled?: boolean;
  invoiceEnabled?: boolean;
  quotationMaxEditableDays?: number;
  localFormEnabled?: boolean;
  requireDocumentUpload?: boolean;
  poaFormEnabled?: boolean;
  minDaysToCancel?: number;
  maxDaysToCancel?: number;
  allowedStatusToCancel?: string;
  enableCustomerLogin?: boolean;
  enableCustomerLoginApi?: boolean;
  accountNumber?: string | null;
  rebateDocumentFrequency?: string | null;
  rebateDocumentSendDates?: string | null;
  localRebateDocumentFrequency?: string | null;
  localRebateDocumentSendDates?: string | null;
  rebateScheduleInternational?: string | null;
  rebateScheduleLocal?: string | null;
  rebateLetterCategoryInternational?: string | null;
  rebateLetterCategoryLocal?: string | null;
  rebateLetterLanguageInternational?: string | null;
  rebateLetterLanguageLocal?: string | null;
  rebateReportSettingsInternational?: string | null;
  rebateReportSettingsLocal?: string | null;
  rebateDocumentAttachSettingsInternational?: string | null;
  rebateDocumentAttachSettingsLocal?: string | null;
}

export const defaultValue: Readonly<IBank> = {};
